import { FC, useEffect, useMemo, useState } from "react";
// import getSupportedLanguagesInRegion from "helpers/getSupportedLanguagesInRegion";
import handleChatWidgetOpen from "helpers/handleChatWidgetOpen";
import emitAiChatInitiatedEvent from "helpers/emitAiChatInitiatedEvent";
import {
  EVENT_LABEL,
  FACEBOOK_MESSENGER_URL,
  GROWTH_BOOK_FEATURE_FLAG_NAMES,
  // WECHAT_CHAT_URL,
} from "constants/index";
// import useLanguageSelector from "hooks/useLanguageSelector";
import classes from "./mobileheader.module.scss";
import MenuItem from "./MenuItem";
import { DropdownMenuProps } from "./types";
import {
  DASHBOARD_URL,
  EMAIL_1,
  GROUP_BOOKINGS_URL,
  HELP_URL,
  HOW_IT_WORKS_URL,
  LEADS_LIST,
  PARTNER_WITH_AMBER_URL,
  PHONE_1,
  PHONE_2,
  PHONE_3,
  PHONE_4,
  PROFILE_DROPDOWN,
  PROFILE_LEADS_URL,
  PROFILE_SHORTLIST_URL,
  PROFILE_URL,
  REFER_URL,
  WHATSAPP_URL,
} from "constants/configConstants";
import { isInternalUser } from "helpers/auth";
import config from "@Config/index";
import AppPromotionBanner from "@Components/AppPromotionBanner";
import HeadPhoneIcon from "@Icons/HeadPhoneIcon";
import ShortlistIcon from "@Icons/ShortlistIcon";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import LoginDispatcher from "@Components/Login/actions";
import HowItWorks from "@Icons/HowItWorks";
// import PhoneIcon from "@Icons/PhoneIcon";
// import EnvelopeIcon from "@Icons/EnvelopeIcon";
import PartnerWithUsIcon from "@Icons/PartnerWithUsIcon";
import LogoutIcon from "@Icons/LogoutIcon";
import LoginIcon from "@Icons/LoginIcon";
import { logoutRequest } from "@Components/Login/components/helper";
import useTranslationHook from "hooks/useTranslationHook";
// import Globe from "@Icons/Globe";
import WechatGreenOutline from "@Icons/WechatGreenOutline";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import {
  addLoadZendeskParamInURL,
  removeLoadZendeskParamFromURL,
} from "@Pages/PropertyPage/data/helper";
import {
  toggleLoadZendeskAfterLogin,
  setOpenAmberCopilot,
} from "@Pages/PropertyPage/components/ZendeskChat/ChatBotReducer";
import HowItWorksIcon from "@Icons/HowItWorksIcon";
// import ChatIcon from "@Icons/ChatIcon";
// import WhatsAppIcon from "@Icons/WhatsAppIcon";
// import MessengerIcon from "@Icons/MessengerIcon";
import ProfileIcon2 from "@Icons/ProfileIcon2";
import BookingIcon from "@Icons/BookingIcon";
import GroupBookingIcon2 from "@Icons/GroupBookingIcon2";
import ReferAFriendIcon2 from "@Icons/ReferAFriendIcon2";
import ListWithUsIcon2 from "@Icons/ListWithUsIcon2";
import useWhitelabel from "hooks/useWhitelabel";
import formatValidOuterLink from "helpers/formatValidOuterLink";
import WhitelabelMenuItem from "./WhitelabelMenuItem";
import ArrowDiagonalRed from "@Icons/ArrowDiagonalRed";
import PoweredByAmber from "@Pages/WhitelabelHome/components/PoweredByAmber/PoweredByAmber";
import wrapperHOC from "@Utils/wrapperHOC";
import { convertToWhitelabelURL } from "@Pages/WhitelabelHome/Desktop/helpers/WhiteLabelRedirectionHelper";
import useIsDesktop from "hooks/useIsDesktop";
import useIsMiniProgram from "hooks/useIsMiniProgram";
import getWeComUrlBasedOnSource, {
  HK_WEIXIN_DWEB,
  HK_WEIXIN_MWEB,
} from "helpers/getWeComUrlBasedOnSource";
import LanguageSelectorModalMobile from "@Components/LanguageSelectorModal/LanguageSelectorModalMobile";
import LanguageSelectorModalSSR from "@Components/LanguageSelectorModal/LanguageSelectorModalSSR";
import Portal from "@Components/Portal";
import Modal from "@Components/Modal";
import LanguagePreference from "@Icons/LanguagePreference";
import Chevron from "@Icons/Chevron";
import { languagesForAmberUserWebsite } from "locales/langConfig/langConfig";
import useIsLanguage from "hooks/useIsLanguage";
import WhitelabelPartnerWeChatQr from "./components/WhitelabelPartnerWeChatQr";
import currencyData from "constants/currencyConstants";
import { SmartFilterLogo } from "@Pages/Search/components/FilterSection/components/SmartFilters/icons";
import WhatsAppColorFilled from "@Icons/WhatsAppColorFilled";
import MessengerColorIcon from "@Icons/MessengerColorIcon";
import PhoneIconColor from "@Icons/PhoneIconColor";
import EnvelopeColor from "@Icons/EnvelopeColor";
import AgentContainer from "@Pages/Support/Component/AgentContainer";
import ChatIcon from "@Icons/ChatIcon";

const DropdownMenu: FC<DropdownMenuProps> = ({
  handleEventEmitter: handleEvent,
  hideExtraMenuItems = false,
  isAmberPlusHeader = false,
  showLangSelector = true,
}) => {
  const {
    SUPPORT_CLICKED,
    QUICK_CHAT_CLICKED,
    HELP_CENTRE_CLICKED,
    HOW_IT_WORKS_CLICKED,
    WHATSAPP_CLICKED,
    FACEBOOK_CLICKED,
    PHONE_CLICKED,
    EMAIL_CLICKED,
    SHORTLIST_CLICKED,
    PROFILE_CLICKED,
    BOOKINGS_CLICKED,
    GROUP_BOOKINGS_CLICKED,
    REFER_CLICKED,
    PARTNER_WITH_US_CLICKED,
    LIST_WITH_US_CLICKED,
    LOGOUT_CLICKED,
    LOGIN_CLICKED,
    WECHAT_CLICKED,
  } = EVENT_LABEL;
  const {
    country,
    userData,
    region,
    isUserLoggedIn,
    loadZendeskAfterLogin,
    isLFOneFilled,
    userCurrency,
    currencyExchangeRates,
    metaObj,
  } = useSelector(
    ({ appData, searchPageData, chatBotReducer, leadFormModal }: AppState) => ({
      country: appData.country,
      userData: appData.userData,
      isUserLoggedIn: appData.isUserLoggedIn,
      region: searchPageData.region,
      loadZendeskAfterLogin: chatBotReducer.loadZendeskAfterLoad,
      isLFOneFilled: leadFormModal.isLFOneFilled,
      userCurrency: appData.userCurrency,
      currencyExchangeRates: appData.currencyExchangeRates,
      metaObj: appData.metaObj,
    }),
    shallowEqual,
  );
  const {
    isWhitelabel,
    whitelabelConfig,
    isDemoSubdomain,
    partner_uuid,
    partner_id,
    isPoweredByAmberEnabledForWhitelabelFooter,
  } = useWhitelabel();
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const isZendeskAfterLogin = useFeatureIsOn(GROWTH_BOOK_FEATURE_FLAG_NAMES.ZENDESK_LOGIN_POPUP);
  const isAmberCopilotEnabled = useFeatureIsOn(GROWTH_BOOK_FEATURE_FLAG_NAMES.AMBER_COPILOT);
  const isMiniProgram = useIsMiniProgram();
  const isCurrencyFeatureEnabled = useFeatureIsOn(
    GROWTH_BOOK_FEATURE_FLAG_NAMES.ONE_PLATFORM_CURRENCY_CHANGES,
  );
  const [weChatSupportRedirectTo, setWeChatSupportRedirectTo] = useState(
    isDesktop ? HK_WEIXIN_DWEB : HK_WEIXIN_MWEB,
  );
  const [showAgentContainer, setShowAgentContainer] = useState(false);

  const userCurrencySymbol =
    currencyData.find(
      (it) => it.standard_name?.toLocaleLowerCase() === userCurrency?.toLocaleLowerCase(),
    )?.symbol || "";

  const handleEventEmitter = (inputVal: any) => {
    if (handleEvent) {
      handleEvent(inputVal);
    }
  };

  const handleLogoutClick = async () => {
    if (isMiniProgram) {
      // @ts-ignore
      if (window.wx && window.wx.miniProgram) {
        handleEventEmitter({ action: LOGOUT_CLICKED });
        const { data, error } = await logoutRequest();
        if (data) {
          window.location.reload();
        } else {
          console.log(error);
        }
      }
      return;
    }
    handleEventEmitter({ action: LOGOUT_CLICKED });
    const { data, error } = await logoutRequest();
    if (data) {
      window.location.reload();
    } else {
      console.log(error);
    }
  };

  const handleLoginClick = () => {
    const loginDispatcher = new LoginDispatcher(dispatch);
    loginDispatcher.showLoginModal({});
    handleEventEmitter({ action: LOGIN_CLICKED });
  };
  // const { language, handleLanguageChange } = useLanguageSelector({ handleEventEmitter });

  const COUNTRIES = {
    AU: "AU",
    US: "US",
    GB: "GB",
    IN: "IN",
  };

  // const supportedLanguages = getSupportedLanguagesInRegion();

  const { t } = useTranslationHook();
  const loginToContinueText = t("home.herosection.header.logintocontinue");
  const loginText = t("home.herosection.header.login");
  const quickLinksText = t("home.herosection.header.quicklinks");
  const supportNowText = t("home.herosection.header.supportnow");

  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [displayWhitelabelWeChatSupportQR, setDisplayWhitelabelWeChatSupportQR] = useState(false);

  const handleLanguageModalOpen = () => {
    setShowLanguageModal(true);
    handleEventEmitter({ action: "language_modal_clicked" });
  };

  const handleLanguageModalClose = () => {
    setShowLanguageModal(false);
  };

  const handleQrModalClose = () => {
    setDisplayWhitelabelWeChatSupportQR(false);
  };

  const handleZendeskClick = () => {
    handleEventEmitter({ action: QUICK_CHAT_CLICKED });

    // If Amber Copilot is enabled, open chatbot instead of zendesk
    if (isAmberCopilotEnabled) {
      dispatch(setOpenAmberCopilot(true));
      emitAiChatInitiatedEvent();
      return;
    }

    if (isZendeskAfterLogin && !isUserLoggedIn && !isLFOneFilled) {
      addLoadZendeskParamInURL();
      const loginDispatcher = new LoginDispatcher(dispatch);
      loginDispatcher.showLoginModal({ openingSource: "zendesk" });
    } else {
      handleChatWidgetOpen(true);
    }
  };

  useEffect(() => {
    const { URLDweb, URLMweb } = getWeComUrlBasedOnSource();
    setWeChatSupportRedirectTo(isDesktop ? URLDweb : URLMweb);
  }, [isDesktop]);

  useEffect(() => {
    if (isZendeskAfterLogin && loadZendeskAfterLogin) {
      removeLoadZendeskParamFromURL();
      dispatch(toggleLoadZendeskAfterLogin(false));
      if (isAmberCopilotEnabled) {
        dispatch(setOpenAmberCopilot(true));
        emitAiChatInitiatedEvent();
      } else {
        handleChatWidgetOpen(true);
      }
    }
  }, [isZendeskAfterLogin, loadZendeskAfterLogin, isAmberCopilotEnabled, dispatch]);

  const userLanguage = useIsLanguage();

  const showWhitelabelWeChatSupportQR = partner_id == "93557";

  const referBonus = useMemo(() => {
    let referBonusPrice = 50;
    let referCurrency = "GBP";

    if (currencyExchangeRates?.baseCurrency) {
      const exchangeRate = currencyExchangeRates?.rates?.find(
        (rate) => rate.target_currency?.toLowerCase() === referCurrency.toLowerCase(),
      );

      if (exchangeRate?.rate) {
        referBonusPrice = Math.ceil(Number(referBonusPrice) / exchangeRate.rate);
        referCurrency = currencyExchangeRates.baseCurrency.toUpperCase();
      }
    }

    return `${referBonusPrice} ${referCurrency}`;
  }, [currencyExchangeRates?.baseCurrency]);

  return (
    <>
      <h4 data-testid="homepage-menu-modal-header" className={classes.modalHeader}>
        {t("home.herosection.header.menu")}
      </h4>
      {/* Default Menu Options */}
      <div className={classes.menuContainer}>
        {/* {config.IS_CHINA_APP && (
          <MenuItem
            label={t("home.herosection.header.language")}
            icon={<Globe width="16" height="16" fill="#000" />}
            defaultOpened
          >
            <div className={classes.subMenu}>
              {supportedLanguages.map(({ label, value }) => (
                <MenuItem
                  label={label}
                  key={value}
                  clickHandler={() => handleLanguageChange(value)}
                  active={label === language}
                  color="danger.6"
                />
              ))}
            </div>
          </MenuItem>
        )} */}

        {!isWhitelabel && (
          <>
            {!showWhitelabelWeChatSupportQR ? (
              <MenuItem
                label={t("home.herosection.header.support")}
                clickHandler={() => {
                  handleEventEmitter({ action: SUPPORT_CLICKED });
                }}
                icon={<HeadPhoneIcon width={16} height={16} fill="#000" />}
              >
                <div className={classes.subMenu}>
                  {!isWhitelabel && (
                    <>
                      <div
                        data-testid="topnav-menu-modal-quick-links"
                        className={classes.sectionSubtitleLeft}
                      >
                        {quickLinksText}
                      </div>
                      <div className={classes.flex}>
                        <MenuItem
                          label={t("home.herosection.header.helpcenter")}
                          icon={<HowItWorks width={16} height={16} fill="#000" />}
                          redirectTo={HELP_URL}
                          clickHandler={() =>
                            handleEventEmitter({
                              action: HELP_CENTRE_CLICKED,
                              click_location: "support",
                            })
                          }
                        />
                        <MenuItem
                          label={t("home.herosection.support.howitworks")}
                          icon={<HowItWorksIcon />}
                          redirectTo={HOW_IT_WORKS_URL}
                          clickHandler={() => handleEventEmitter({ action: HOW_IT_WORKS_CLICKED })}
                        />
                      </div>
                    </>
                  )}

                  <AgentContainer setShowAgentContainer={setShowAgentContainer} />

                  <div className={showAgentContainer ? classes.withPadding : classes.divider} />

                  {!isWhitelabel && (
                    <>
                      <div
                        data-testid="topnav-menu-modal-support-now"
                        className={classes.sectionSubtitle}
                      >
                        {supportNowText}
                      </div>
                      {/* {!config.IS_CHINA_APP && ( */}
                      <MenuItem
                        label={t("home.herosection.support.quickchat")}
                        icon={config.IS_CHINA_APP ? <ChatIcon /> : <SmartFilterLogo />}
                        showFullRightSection
                        rightSection={t("profile.support.components.supportlistitem.instantreply")}
                        clickHandler={handleZendeskClick}
                      />
                      {/* )} */}
                    </>
                  )}
                  {config.IS_CHINA_APP ? (
                    <MenuItem
                      label="home.herosection.support.wechat"
                      icon={<WechatGreenOutline />}
                      redirectTo={weChatSupportRedirectTo}
                      clickHandler={() => handleEventEmitter({ action: WECHAT_CLICKED })}
                    />
                  ) : (
                    <>
                      <MenuItem
                        label="home.herosection.support.whatsapp"
                        icon={<WhatsAppColorFilled />}
                        redirectTo={WHATSAPP_URL}
                        clickHandler={() => handleEventEmitter({ action: WHATSAPP_CLICKED })}
                      />

                      {!isWhitelabel && (
                        <MenuItem
                          label={t("home.herosection.support.facebookmessenger")}
                          icon={<MessengerColorIcon fill="#0084FF" />}
                          redirectTo={FACEBOOK_MESSENGER_URL}
                          clickHandler={() => handleEventEmitter({ action: FACEBOOK_CLICKED })}
                        />
                      )}
                    </>
                  )}

                  {!config.IS_CHINA_APP && <div className={classes.divider} />}

                  {(() => {
                    const phoneMap: Record<string, { full_number: string } | undefined> = {
                      [COUNTRIES.GB]: PHONE_1,
                      [COUNTRIES.US]: PHONE_3,
                      [COUNTRIES.AU]: PHONE_4,
                      [COUNTRIES.IN]: !config?.IS_CHINA_APP ? PHONE_2 : undefined,
                    };
                    const phone = phoneMap[country];
                    return phone ? (
                      <MenuItem
                        label={phone.full_number}
                        redirectTo={`tel:${phone.full_number}`}
                        icon={<PhoneIconColor width="16" height="16" fill="#3F83F8" />}
                        clickHandler={() => handleEventEmitter(PHONE_CLICKED)}
                      />
                    ) : null;
                  })()}

                  <div className={classes.divider} />

                  <MenuItem
                    label={EMAIL_1}
                    redirectTo={`mailto:${EMAIL_1}`}
                    icon={<EnvelopeColor />}
                    clickHandler={() => handleEventEmitter({ action: EMAIL_CLICKED })}
                  />
                </div>
              </MenuItem>
            ) : (
              <MenuItem
                label={t("Support")}
                clickHandler={() => {
                  handleEventEmitter({ action: SUPPORT_CLICKED });
                  setDisplayWhitelabelWeChatSupportQR(true);
                }}
                icon={<HeadPhoneIcon width={16} height={16} fill="#000" />}
              />
            )}
          </>
        )}

        {!hideExtraMenuItems && (
          <MenuItem
            label={t("home.herosection.header.shortlist")}
            icon={<ShortlistIcon size={16} fill="#000" />}
            redirectTo={
              isWhitelabel
                ? convertToWhitelabelURL(PROFILE_SHORTLIST_URL, isDemoSubdomain, partner_uuid)
                : PROFILE_SHORTLIST_URL
            }
            clickHandler={() => handleEventEmitter({ action: SHORTLIST_CLICKED, label: region })}
            addLangPrefixToUrl
          />
        )}

        {showLangSelector && !isWhitelabel && !isAmberPlusHeader && (
          <div className={classes.preference}>
            <MenuItem
              label={`${t("Select Preferences")} ${
                languagesForAmberUserWebsite.find((lang) => lang.code === userLanguage)
                  ?.shortDisplayText || "En"
              }${userCurrencySymbol ? ` · ${userCurrencySymbol}` : ""}`}
              icon={<LanguagePreference />}
              clickHandler={handleLanguageModalOpen}
            />
            <Chevron height="12" width="12" rotate="270" />
          </div>
        )}

        {isInternalUser(userData) && (
          <MenuItem
            label="Dashboard"
            icon={<i className="icon-dashboard" />}
            redirectTo={DASHBOARD_URL}
          />
        )}

        {!isWhitelabel && <div className={classes.divider} />}

        {/* Personal Menu Options */}
        {!isUserLoggedIn && (
          <div
            data-testid="homepage-topnav-login-options"
            className={isWhitelabel ? classes.backgroundHightlight : classes.highlight}
          >
            {loginToContinueText}
          </div>
        )}

        <MenuItem
          label={t("home.herosection.header.profile")}
          icon={<ProfileIcon2 />}
          redirectTo={
            isWhitelabel
              ? convertToWhitelabelURL(PROFILE_URL, isDemoSubdomain, partner_uuid)
              : PROFILE_URL
          }
          clickHandler={() => handleEventEmitter({ action: PROFILE_CLICKED })}
          addLangPrefixToUrl
        />

        <MenuItem
          label={t("home.herosection.header.bookings")}
          icon={<BookingIcon />}
          redirectTo={
            isWhitelabel
              ? convertToWhitelabelURL(PROFILE_LEADS_URL, isDemoSubdomain, partner_uuid)
              : PROFILE_LEADS_URL
          }
          clickHandler={() => handleEventEmitter({ action: BOOKINGS_CLICKED })}
          addLangPrefixToUrl
        />

        <div className={classes.divider} />

        {!hideExtraMenuItems && !isWhitelabel ? (
          <>
            {/* Website Menu Options, not needed now */}
            <MenuItem
              label={t("home.herosection.header.groupbooking")}
              icon={<GroupBookingIcon2 />}
              rightSection={t("home.herosection.header.new")}
              redirectTo={GROUP_BOOKINGS_URL}
              clickHandler={() => handleEventEmitter({ action: GROUP_BOOKINGS_CLICKED })}
            />
            {/* <MenuItem label='Offers' icon={<i className='icon-offers-1' />} /> */}

            <MenuItem
              label={t("home.herosection.header.referafriend")}
              icon={<ReferAFriendIcon2 />}
              rightSection={`${t("home.herosection.header.get")} ${referBonus}`}
              redirectTo={REFER_URL}
              clickHandler={() => handleEventEmitter({ action: REFER_CLICKED })}
            />
            <MenuItem
              label={t("home.herosection.header.partnerwithus")}
              icon={<PartnerWithUsIcon width={16} height={16} fill="#000" />}
              redirectTo={PARTNER_WITH_AMBER_URL}
              clickHandler={() => handleEventEmitter({ action: PARTNER_WITH_US_CLICKED })}
            />
            <MenuItem
              label={t("home.herosection.header.listwithus")}
              icon={<ListWithUsIcon2 />}
              redirectTo={LEADS_LIST}
              clickHandler={() => handleEventEmitter({ action: LIST_WITH_US_CLICKED })}
            />
            <div className={classes.divider} />
          </>
        ) : (
          whitelabelConfig?.is_custom_link_enabled && (
            <>
              {whitelabelConfig?.custom_links?.map((link: any) => {
                const validLink = formatValidOuterLink(link.link);
                return (
                  <WhitelabelMenuItem
                    label={link.title}
                    icon={<ArrowDiagonalRed fill="#111928" />}
                    {...(link.link && {
                      redirectTo: validLink,
                    })}
                  />
                );
              })}
              {isUserLoggedIn && <div className={classes.divider} />}
            </>
          )
        )}
        {/* <MenuItem label='EN / RS' icon={<i className='icon-globe' />} />

      <div className={classes.div} /> */}
        {config.BEANSTALK_APP_NAME != "webapp-hk" && !isWhitelabel && !hideExtraMenuItems && (
          <div
            className={classes.appBanner}
            style={{
              marginBottom: isUserLoggedIn ? "0px" : "61px",
            }}
          >
            <AppPromotionBanner from={PROFILE_DROPDOWN} />
          </div>
        )}
        {isUserLoggedIn ? (
          <MenuItem
            icon={<LogoutIcon width={16} height={16} fill="#000" />}
            label={t("home.herosection.header.logout")}
            clickHandler={handleLogoutClick}
          />
        ) : (
          <div className={classes.loginButtonContainer}>
            <button
              data-testid="topnav-menu-modal-login-button"
              type="button"
              onClick={handleLoginClick}
              className={classes.loginButton}
            >
              <LoginIcon width={16} height={16} fill="#000" />
              {loginText}
            </button>
          </div>
        )}

        {isWhitelabel && !isPoweredByAmberEnabledForWhitelabelFooter && (
          <div
            className={
              isUserLoggedIn ? classes.poweredByAmberLoggedIn : classes.poweredByAmberLoggedOut
            }
          >
            <PoweredByAmber />
          </div>
        )}
      </div>

      {/* SSR-only language selector for SEO crawlers */}
      <LanguageSelectorModalSSR
        userLanguage={userLanguage}
        canonicalUrl={metaObj?.canonical_url_suffix}
      />

      {showLanguageModal && (
        <Portal rootId="forPortal">
          <Modal
            hideModal={handleLanguageModalClose}
            size="fullScreen"
            animation="bottomToTop"
            zIndex={1200}
          >
            <LanguageSelectorModalMobile
              onClose={handleLanguageModalClose}
              isCurrencyFeatureEnabled={isCurrencyFeatureEnabled}
            />
          </Modal>
        </Portal>
      )}

      {displayWhitelabelWeChatSupportQR && (
        <Modal
          hideModal={handleQrModalClose}
          size="fitContent"
          animation="bottomToTop"
          align="center"
          className={classes.wechatSupportQRModal}
        >
          <WhitelabelPartnerWeChatQr />
        </Modal>
      )}
    </>
  );
};

export default wrapperHOC(DropdownMenu, {
  componentName: "DropDownMenu-Header",
  showForChina: true,
});
